<template>
  <div class="common-box">
    <el-row class="row-one">
      <span class="row-one-title">基金组合调仓记录</span>
      <Reback class="row-one-fr" @click.native="$router.push({ name: 'myAssets' })"></Reback>
      <span class="row-one-fr" @click="detailsClick">查看资产详情</span>
    </el-row>
    <!-- 表格 -->
    <el-table :data="tradeTableData" class="table-single margin-t20" stripe v-loading="loading" element-loading-text="加载中...">
      <el-table-column prop="combinationName" label="组合名称"></el-table-column>
      <el-table-column prop="storehousedate" label="方案发布时间"></el-table-column>
      <el-table-column prop="operdate" label="调仓操作时间"></el-table-column>
      <el-table-column prop="statusName" label="交易状态">
        <template slot-scope="scope">
          <span v-if="scope.row.statusName == '已跟调'" class="gColor">{{scope.row.statusName}}</span>
          <span v-else-if="scope.row.statusName == '调仓中'" class="aColor">{{scope.row.statusName}}</span>
          <span v-else>{{scope.row.statusName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="details" label="详情">
        <template slot-scope="scope">
          <span class="table-single-btn-normal" @click="recordDetailClick(scope.row)">详情</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <!-- <el-pagination class="pagination-single" @current-change="handleCurrentChangeOne" :current-page.sync="trade.Page" :page-size="trade.PageNum" layout="prev, pager, next" :total="total" hide-on-single-page>
    </el-pagination> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      tradeTableData: [],
      //   trade: {
      //     Page: 1,
      //     PageNum: 20
      //   },
      //   total: 0,
    }
  },
  mounted () {
    this.getAdjustRecord()
  },
  methods: {
    recordDetailClick (row) {
      this.$router.push({ name: 'combinationAdjustRecordDetail', params: { message: row } })
    },
    detailsClick () {
      this.$router.push({
        name: 'combinationAssetsMessage',
        params: {
          value: 'combinationAdjustRecord'
        },
      })
    },
    // 调仓记录
    getAdjustRecord () {
      this.$http.get(this.$apiPath.getTiaocangState, {
        custno: this.$commonJs.getCookie('u_custno1'),
      }).then(res => {
        this.tradeTableData = this.$commonJs.getJsonByXml(res.data).stateInfo//转换xml格式
        this.tradeTableData.forEach(item => {
          item.storehousedate = this.$commonJs.getDateStrHg(item.storehousedate)
          item.operdate = this.$commonJs.getDateStrHg(item.operdate)
          item.combinationName = this.$commonJs.getCombinationNameByCode(item.combinationcode)
          if (item.status == 2 || item.status == 6) {
            item.statusName = "调仓中"
          } else if (item.status == 8) {
            item.statusName = "已跟调"
          } else if (item.status == 4 || item.status == 5) {
            item.statusName = "已撤单"
          }

        })
      }).catch(err => { })
    }
  }
}
</script>

<style lang="less" scoped>
</style>